import {
  AzureOfferPlan,
  AzurePricingType,
  RecurrentPriceModeType,
} from '../../../modules/privateOffer/reducer'
import { useStyles } from './Sections.styles'
import { SectionWrapper } from '../../../common/components/SectionWrapper/SectionWrapper'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { Divider } from '@mui/material'
import clsx from 'clsx'
import { PlanBasicDetail } from './PlanComponents/PlanBasicDetail'
import { PlanBillingTerms } from './PlanComponents/PlanBillingTerms'
import { PlanContractDetails } from './PlanComponents/PlanContractDetails'
import { Installments } from './PlanComponents/Installments'
import { MeteringPlans } from './PlanComponents/MeteringPlans'
import { useSelector } from '../../../store'
import { MsftCombinedFormState } from '../../../modules/microsoftCombinedForm/reducer'
import { Product } from '../../../modules/productsListing/reducer'
import { useFlyOutProductsBasedOnSelectedCloud } from '../../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import { PlanMinMax } from '../../MicrosoftViewPricing/PlanMinMax/PlanMinMax'

export const Pricing = ({
  plans,
  azurePricingType,
  viewingPersona,
}: {
  plans?: AzureOfferPlan[]
  azurePricingType?: AzurePricingType
  viewingPersona: string
}) => {
  const { classes } = useStyles()
  const { products } = useFlyOutProductsBasedOnSelectedCloud()
  const combinedFormData = useSelector<MsftCombinedFormState>(
    state => state.microsoftCombinedForm
  )
  const isISV = viewingPersona !== 'CP'
  const selectedProductId = combinedFormData?.draftOffer?.labraProductId
  const product =
    products.find(product => product.productId === selectedProductId) ||
    ({} as Product)

  if (!plans || plans.length === 0) {
    return (
      <div>
        <SectionWrapper
          heading="Pricing Plans"
          icon={faListCheck}
          varient="small"
        >
          <div className={classes.sectionContent}>
            <div className={classes.emptyState}>No plans available</div>
          </div>
        </SectionWrapper>
      </div>
    )
  }
  return (
    <div>
      <SectionWrapper heading="Pricing" icon={faListCheck} varient="small">
        <div className={classes.sectionContent}>
          {plans.map((plan, index) => {
            const recurrentPriceMode =
              plan.pricing?.recurrentPrice?.recurrentPriceMode
            const shouldShowInstallments =
              plan.pricing?.recurrentPrice?.prices[0]?.installments &&
              plan.pricing?.recurrentPrice?.prices[0]?.installments?.schedule
                ?.length
            const shouldShowMeteringPlans =
              plan.pricing?.recurrentPrice?.recurrentPriceMode ===
                RecurrentPriceModeType.FLATRATE &&
              plan.pricing?.customMeters &&
              Object.keys(plan.pricing.customMeters.meters || {}).length > 0
            const shouldShowUserMinMax =
              plan?.pricing?.recurrentPrice?.recurrentPriceMode ===
              RecurrentPriceModeType.PERUSER
            const isPricePerUser = shouldShowUserMinMax && !isISV
            return (
              <div key={plan.planId || index} className={classes.planCard}>
                <PlanBasicDetail plan={plan} product={product} />
                <Divider className={classes.divider} />
                <PlanContractDetails
                  plan={plan}
                  isISV={isISV}
                  isPricePerUser={isPricePerUser}
                />
                <Divider className={classes.divider} />
                {!isISV && (
                  <PlanBillingTerms
                    plan={plan}
                    azurePricingType={azurePricingType}
                    recurrentPriceMode={recurrentPriceMode}
                  />
                )}
                <>
                  {shouldShowUserMinMax && (
                    <>
                      <Divider className={clsx(classes.divider)} />
                      <PlanMinMax plan={plan} />
                    </>
                  )}
                  {shouldShowInstallments && (
                    <>
                      <Divider className={clsx(classes.divider)} />
                      <Installments
                        schedule={
                          plan.pricing?.recurrentPrice?.prices[0]?.installments
                            ?.schedule
                        }
                        markupPercentage={plan?.markupPercentage}
                        isISV={isISV}
                      />
                    </>
                  )}
                  {shouldShowMeteringPlans && (
                    <>
                      <Divider className={clsx(classes.divider)} />
                      <MeteringPlans plan={plan} isISV={isISV} />
                    </>
                  )}
                </>
              </div>
            )
          })}
        </div>
      </SectionWrapper>
    </div>
  )
}
